import React from 'react';
import { digiroom } from '../../../assets/images';
import Image from 'next/image';

const InfoDigiroom = () => {
  return (
    <div className="text-reliableBlack bg-[#f4f4f4] py-3 lg:py-11 flex justify-center">
      <div className="flex justify-center items-center container xl:px-0">
        <div className="min-w-[102px] md:min-w-[130px]">
          <Image
            className="h-[88px] w-auto md:w-auto md:h-[115px]"
            src={digiroom.src}
            alt="digiroom logo"
            width={115}
            height={115}
          />
        </div>
        <div className="block ml-2 lg:ml-4 ">
          <p className="text-base lg:text-2xl font-bold md:mb-2">AUTO2000 DIGIROOM</p>
          <p className="text-xs leading-[18px] md:leading-[28px] font-medium md:font-normal md:text-xl md:text-reliableBlack80 md:tracking-[0.4px]">
            Dealer Toyota terbesar di Indonesia yang melayani jaringan jasa penjualan, perawatan,
            perbaikan dan penyediaan suku cadang Toyota yang terbesar di seluruh Indonesia.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InfoDigiroom;
